import clsx from 'clsx';

import { IImageMedia, IVideoMedia } from '~/lib/data-contract';
import { AspectRatio } from '~/shared/components/AspectRatio/AspectRatio';
import { ImageMedia } from '~/shared/components/ImageMedia/ImageMedia';
import { VideoMedia } from '~/shared/components/VideoMedia/VideoMedia';
import { lgCondition, mdCondition, smCondition, xlCondition, xsCondition } from '~/theme/lib/breakpoints';

import styles from '../../m50ShopTheLook.module.css';

export type PositionOptions = 'top' | 'bottom' | 'center';

export type TextMediaCanvasProps = {
	position: PositionOptions;
	image?: IImageMedia;
	video?: IVideoMedia;
	withBackground?: boolean;
	className?: string;
};

const portraitRatio = 336 / 420;
const landscapeRatio = 623 / 415;

export const TextMediaCanvas = ({ image, video, position, withBackground, className }: TextMediaCanvasProps) => {
	const ratios: { [key in PositionOptions]: number } = {
		top: portraitRatio,
		bottom: portraitRatio,
		center: landscapeRatio,
	};

	const ratio = ratios[position];
	const imageSizes = [`${xlCondition} 1280px`, `${lgCondition} 770px`, `${mdCondition} 540px`, `${smCondition} 910px`, `${xsCondition} 560px`].join(', ');

	if (!image && !video) {
		return null;
	}

	return (
		<div
			className={clsx(
				styles.canvas,
				{
					[styles.top]: position === 'top',
					[styles.bottom]: position === 'bottom',
					[styles.center]: position === 'center',
					[styles.withBackground]: withBackground,
				},
				className,
			)}
		>
			<AspectRatio ratio={ratio}>
				{video ? (
					<VideoMedia video={video} />
				) : image ? (
					<ImageMedia
						fill
						objectFit="cover"
						image={image}
						sizes={imageSizes}
					/>
				) : null}
			</AspectRatio>
		</div>
	);
};
